import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

const MyRequests = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    fetchRequests();
  }, [user, navigate]);

  const fetchRequests = async () => {
    try {
      const response = await axios.get('/api/items/my/requests');
      setRequests(response.data);
    } catch (error) {
      console.error('Lỗi khi tải yêu cầu:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (requestId, status) => {
    try {
      await axios.put(`/api/items/requests/${requestId}`, { status });
      fetchRequests();
    } catch (error) {
      alert(error.response?.data?.error || 'Cập nhật thất bại');
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div className="container" style={{ marginTop: '40px' }}>
      <h1 style={{ marginBottom: '24px' }}>Yêu Cầu Nhận Đồ</h1>

      {loading ? (
        <div className="loading">Đang tải...</div>
      ) : requests.length === 0 ? (
        <div className="empty-state">
          <h3>Chưa có yêu cầu nào</h3>
          <p>Khi có người xin món đồ của bạn, yêu cầu sẽ hiển thị ở đây</p>
        </div>
      ) : (
        <div>
          {requests.map(request => (
            <div key={request.id} className="card" style={{ marginBottom: '20px' }}>
              <div className="request-item-container" style={{ display: 'flex', gap: '24px' }}>
                {request.item_image && (
                  <img
                    src={request.item_image}
                    alt={request.item_title}
                    onClick={() => navigate(`/item/${request.item_id}`)}
                    className="request-item-image"
                    style={{ 
                      width: '150px', 
                      height: '150px', 
                      objectFit: 'cover', 
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'opacity 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                    onMouseLeave={(e) => e.target.style.opacity = '1'}
                  />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 
                    style={{ marginBottom: '12px', cursor: 'pointer' }}
                    onClick={() => navigate(`/item/${request.item_id}`)}
                    onMouseEnter={(e) => e.target.style.color = '#7b1fa2'}
                    onMouseLeave={(e) => e.target.style.color = ''}
                  >
                    {request.item_title}
                  </h3>
                  <div style={{ marginBottom: '16px' }}>
                    <p><strong>Người xin:</strong> {request.requester_name || request.requester_username}</p>
                    {request.requester_phone && <p><strong>Điện thoại:</strong> {request.requester_phone}</p>}
                    {request.requester_email && <p><strong>Email:</strong> {request.requester_email}</p>}
                  </div>
                  {request.message && (
                    <div style={{ marginBottom: '16px', padding: '12px', background: '#f5f5f5', borderRadius: '8px' }}>
                      <strong>Lời nhắn:</strong>
                      <p style={{ marginTop: '8px', color: '#666' }}>{request.message}</p>
                    </div>
                  )}
                  <div className="request-actions" style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <span className={`badge ${
                      request.status === 'accepted' ? 'badge-success' :
                      request.status === 'rejected' ? 'badge-danger' :
                      'badge-warning'
                    }`}>
                      {request.status === 'accepted' ? 'Đã chấp nhận' :
                       request.status === 'rejected' ? 'Đã từ chối' :
                       'Đang chờ'}
                    </span>
                    {request.status === 'pending' && (
                      <>
                        <button
                          onClick={() => handleStatusChange(request.id, 'accepted')}
                          className="btn btn-primary"
                        >
                          Chấp Nhận
                        </button>
                        <button
                          onClick={() => handleStatusChange(request.id, 'rejected')}
                          className="btn btn-danger"
                        >
                          Từ Chối
                        </button>
                      </>
                    )}
                  </div>
                  <p style={{ marginTop: '12px', fontSize: '12px', color: '#999' }}>
                    {new Date(request.created_at).toLocaleString('vi-VN')}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyRequests;

